<app-search-input
  [autocomplete]="auto"
  placeholder="Search fabrics by name or reference..."
  ariaLabel="Search fabrics"
  (search)="onSearch($event)"
></app-search-input>

<!-- Panel styling lives in styles/styles.scss under this overlay class: ng-zorro renders the
     panel into the CDK overlay container at body level, out of reach of this component's
     encapsulated styles (::ng-deep included). -->
<nz-autocomplete #auto nzOverlayClassName="fabric-search-panel" (selectionChange)="onSelect($event)">
  @if (loading()) {
    <nz-auto-option class="fabric-search__state" [nzDisabled]="true" nzValue="__loading__">
      <span nz-icon nzType="loading" aria-hidden="true"></span>
      {{ 'Searching...' | t }}
    </nz-auto-option>
  } @else if (results().length) {
    <!-- First on purpose: ng-zorro pre-highlights the first option, so Enter goes to the full
         results while the arrow keys and the mouse pick a single fabric. -->
    @if (hasMore()) {
      <nz-auto-option class="fabric-search__all" [nzValue]="SEE_ALL" [nzLabel]="term()">
        <span>{{ seeAllKey | t: { count: total() } }}</span>
        <span nz-icon nzType="arrow-right" aria-hidden="true"></span>
      </nz-auto-option>
    }

    @for (fabric of results(); track fabric.uuid) {
      <nz-auto-option
        class="fabric-search__row"
        [nzValue]="fabric.uuid"
        [nzLabel]="fabric.article?.name ?? fabric.auxCode"
      >
        <img
          class="fabric-search__thumb"
          loading="lazy"
          decoding="async"
          alt=""
          [src]="fabric.article?.cover?.thumbUrl ?? fallbackImageUrl"
        />
        <span class="fabric-search__text">
          <span class="fabric-search__name">{{ fabric.article?.name ?? fabric.auxCode }}</span>
          <span class="fabric-search__meta">
            <span>{{ fabric.auxCode }}</span>
            @if (isQuoteOnly(fabric)) {
              <span>{{ 'Price on request' | t }}</span>
            } @else if (isSinglePrice(fabric)) {
              <span>{{ fabric.priceRange.min | customCurrency: i18n.locale() }}</span>
            } @else {
              <span>
                {{ fabric.priceRange.min | customCurrency: i18n.locale() }}
                <span class="fabric-search__price-sep">–</span>
                {{ fabric.priceRange.max | customCurrency: i18n.locale() }}
              </span>
            }
          </span>
        </span>
      </nz-auto-option>
    }
  } @else if (searched()) {
    <nz-auto-option class="fabric-search__state" [nzDisabled]="true" nzValue="__empty__">
      {{ 'No fabrics found' | t }}
    </nz-auto-option>
  }
</nz-autocomplete>
